import * as React from 'react';

import { getSearchModalEmptyColor, getSearchModalEmptyText } from './helpers';
import { SearchModalEmpty } from '../../../../components/SearchModal';
import { ESearchModalState } from '../../../../types/searchModal';
import { SearchModalSuggestionsContainer } from '../SearchModalSuggestions';
import { SearchModalTagsContainer } from '../SearchModalTags';

export interface ISearchModalContentContainerProps {
  modalState: ESearchModalState;
  onSuggestionClick?: () => void;
}

export const SearchModalContentContainer: React.FC<ISearchModalContentContainerProps> = props => {
  const { modalState, onSuggestionClick } = props;

  switch (modalState) {
    case ESearchModalState.Tags:
      return <SearchModalTagsContainer />;
    case ESearchModalState.Suggest:
      return <SearchModalSuggestionsContainer onClick={onSuggestionClick} />;
    case ESearchModalState.EmptySuggest:
    case ESearchModalState.EmptyTags:
    case ESearchModalState.SuggestError:
      /* eslint-disable no-case-declarations */
      const color = getSearchModalEmptyColor(modalState);
      const text = getSearchModalEmptyText(modalState);
      /* eslint-enable no-case-declarations */

      return <SearchModalEmpty text={text} color={color} />;
  }
};
